module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_iterators.js
// module id = 129
// module chunks = 1